require('./helpers/bundle-manifest').register(JSON.parse("{\"22lFf\":\"index.72f58017.js\",\"5JJPA\":\"logo.ae148070.png\"}"));